/**
 * Shared enquiry popup — opened from any [data-enquire-trigger] button.
 * Reads product info from the trigger's data attributes and fills the
 * modal's hidden field + product preview before showing it.
 */
(function () {
  'use strict';

  function initModal(modal) {
    var successEl = modal.querySelector('[data-role="enquiry-success"]');
    var fieldsEl = modal.querySelector('[data-role="enquiry-fields"]');

    function open(trigger) {
      var title = trigger.getAttribute('data-product-title') || '';
      var code = trigger.getAttribute('data-product-code') || '';
      var url = trigger.getAttribute('data-product-url') || window.location.href;
      var image = trigger.getAttribute('data-product-image') || '';

      var productField = modal.querySelector('[data-role="enquiry-product-field"]');
      if (productField) {
        var label = title;
        if (code) label += ' (' + code + ')';
        productField.value = label + ' — ' + window.location.origin + url;
      }

      var productBox = modal.querySelector('[data-role="enquiry-product"]');
      var nameEl = modal.querySelector('[data-role="enquiry-product-name"]');
      var codeEl = modal.querySelector('[data-role="enquiry-product-code"]');
      var imgEl = modal.querySelector('[data-role="enquiry-product-img"]');

      if (title && productBox) {
        productBox.hidden = false;
        if (nameEl) nameEl.textContent = title;
        if (codeEl) codeEl.textContent = code;
        if (imgEl) imgEl.style.backgroundImage = image ? 'url(' + image + ')' : '';
      } else if (productBox) {
        productBox.hidden = true;
      }

      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    modal.querySelectorAll('[data-role="enquiry-close"]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-enquire-trigger]');
      if (!trigger) return;
      e.preventDefault();
      open(trigger);
    });

    // If the server already rendered a success state (posted_successfully?),
    // open the modal so the visitor sees the confirmation.
    if (successEl && successEl.classList.contains('show')) {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
  }

  document.querySelectorAll('[data-role="enquiry-modal"]').forEach(initModal);
})();
